import type { WorkSessionsState } from '../../../types';

type Props = {
  month: number,
  day: number,
  dayName: string,
  date: string,
  isToday: boolean,
  workSessions: WorkSessionsState,
  deskLabel?: string,
}
const getSessionIcon = (sessionType: string) => {
  switch (sessionType) {
    case 'on_site':
      return "🏢";
    case 'remote':
      return "🏠";
    case 'business_trip':
      return "✈️";
    case 'sick':
      return "🤒";
    case 'remote_sick':
      return "🏥";
    case 'vacation':
      return "🌴";
    default:
      return <i className="fa fa-clock-o" aria-hidden="true" title={sessionType} />;
  }
};

const DayHeading = (props: Props) => {
  const {
    month, day, dayName,
    date,
    isToday,
    workSessions,
    deskLabel,
  } = props;
  let dayHeadingClasses = 'col text-center individual-day js-day-navigation';
  if (isToday) {
    dayHeadingClasses += ' highlight-today';
  }

  // Find work session for this date
  const workSession = Object.values(workSessions.byId).find(
    session => session.date === date
  );

  // Extract check-in time from checkinTime
  const getCheckinTime = (checkinTime: string) => {
    const checkinDate = new Date(checkinTime);
    const hours = checkinDate.getHours().toString().padStart(2, '0');
    const minutes = checkinDate.getMinutes().toString().padStart(2, '0');

    return `${hours}:${minutes}`;
  };

  return (
    <div className={dayHeadingClasses} data-day={`${month}-${day}`}>
      <div>{`${dayName} ${day}/${month}`}</div>
      {((workSession && workSession.checkinTime) || deskLabel) && (
        <div style={{ fontSize: '0.85em', color: '#ABB0CB' }}>
          {workSession && workSession.checkinTime && (
            <>
              {getSessionIcon(workSession.sessionType)}
              {' '}{getCheckinTime(workSession.checkinTime)}{' '}
            </>
          )}
          {deskLabel && (
            <span title={`Desk ${deskLabel}`}>
              <i className="fa fa-desktop" aria-hidden="true" /> {deskLabel}
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default DayHeading;
